import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import moment from 'moment';
// 사용자 정의 모듈.
import * as config from './config';

Vue.use(Vuex);
let timeDiffFlag = false;
const createAxiosParams = (store, payload) => {
    // store_id 공통 설정.
    if (payload.type.method == 'get') {
        if (!payload.data) {
            payload.data = { store_id: store.getters['getStoreId'] };
        } else {
            if (!payload.data.store_id) {
                payload.data.store_id = store.getters['getStoreId'];
            }
        }
    } else {
        if (!payload.data.data) {
            payload.data.data = { store_id: store.getters['getStoreId'] };
        } else {
            if (!payload.data.data.store_id) {
                payload.data.data.store_id = store.getters['getStoreId'];
            }
        }
    }

    // 서버 요청 파라미터 생성.
    const reqURL = store.getters['getHost'] + payload.type.url;
    const reqData = (payload.type.method == 'get') ? { params: payload.data } : payload.data;
    const reqHeaders = { headers: { 'x-access-token': store.getters['getToken'] } };

    let axiosParams = new Object();
    axiosParams.reqURL = reqURL;
    axiosParams.reqData = reqData;
    axiosParams.reqHeaders = reqHeaders;
    axiosParams.payload = payload;

    return axiosParams;
}
const getAxiosInsctance = (axiosParms) => {
    if (axiosParms.payload.type.method == 'get') {
        return axios[axiosParms.payload.type.method](axiosParms.reqURL, Object.assign({}, axiosParms.reqData, axiosParms.reqHeaders));
    } else {
        return axios[axiosParms.payload.type.method](axiosParms.reqURL, axiosParms.reqData, axiosParms.reqHeaders);
    }
}

export default new Vuex.Store({
    state: {
        //glober
        // 서버 호스트 정보.
        host: config.HOST,
        // 서버 호스트 정보.
        POPUP_CODE: {
            // 출입문 개방 팝업
            ALL_CLOSE: 0,
            // 출입문 개방 팝업
            POPUP_DOOR_OPEN: 1,
            // 출입증 출력 팝업
            POPUP_BARCODE_PRINT: 2,
            // 미가입 고객 회원가입 팝업
            POPUP_JOIN: 3,
            // 이용종료 팝업
            POPUP_USE_FINISH: 4,
            // 좌석이동 팝업
            POPUP_SEAT_MOVE: 5,
            // 퇴실문자 팝업
            POPUP_CHECK_OUT_TEXT: 6,
            // 이용종료 팝업
            POPUP_USE_FINISH_S: 7,
            // 입실문자 팝업
            POPUP_CHECK_IN_TEXT: 8,
            // 이미사용중인 좌석 팝업
            POPUP_ALREADY_USE_SEAT: 9,
            // 이미사용중인 사물함 팝업
            POPUP_POPUP_ALREADY_USE_LOCKER: 10,
            // 좌석 이용종류 팝업
            POPUP_USE_SEAT_TYPE: 11,
            // 사물함 이용종류 팝업
            POPUP_USE_LOCKER_TYPE: 12,
            // 사물함 이동확인 팝업
            POPUP_LOCKER_MOVE_CHECK: 13,
            // 빈 사물함 팝업
            POPUP_EMPTY_LOCKER: 14,
            // 그룹룸 이용종류 팝업
            POPUP_USE_TYPE: 15,
            // 좌석이동 불가 팝업
            POPUP_UNAVAILABLE_MOVE_SEAT: 16,
            // 그룹룸 예약 결제 팝업
            POPUP_GROOM_RESERVATION_PAYMENT: 17,
            // 좌석상품 사용 되물음 팝업
            POPUP_SEAT_PRODUCT_USE_ASK_AGAIN: 18,
            // 좌석 - 내상품/쿠폰목록
            POPUP_SEAT_USE_PRODUCT_COUPON_LIST : 19,
            // 그룹룸 구매목록
            POPUP_GROOM_USE_PRODUCT_LIST : 20,
            // 좌석_이동 배치도
            POPUP_SEAT_MOVE_MAP : 21,
            // locker_이동 배치도
            POPUP_LOCKER_MOVE_MAP: 22,
            // 재입장 시 출입문 선택
            POPUP_DOOR_KIND_LIST: 23,
            // 그룹룸 이용종료
            POPUP_GROOM_END: 24,
            // 퇴실 임박 좌석
            POPUP_OUT_SOON: 25,
            // 영수증 출력 미출력 팝업
            POPUP_RECEIPT_YN: 26,
            // 이용종료안내 팝업
            POPUP_END_GUIDE: 27,
            // 좌석이동 중 문제 발생
            POPUP_MOVE_PROBLEM: 28,
            // 좌석선택시 검증
            POPUP_USING_CHECK: 29,
            // 좌석선택시 검증
            POPUP_BARCODE_EXPANTION: 30,
            // 현금영수증 취소(재시도 버튼)
            POPUP_CASH_RETRY: 96,
            // 카드결제 실패(결제 재시도 버튼)
            POPUP_CARD_RETRY: 97,
            // 메세지 확인 팝업(닫기버튼 없음)
            POPUP_ALERT_NONE_CLOSE: 98,
            // 메세지 확인 팝업
            POPUP_ALERT: 99,
            // 예약 결제 확인 팝업
            POPUP_GROOM_RESERVATION_PAY: 103,
            // 문자 인증 팝업
            POPUP_AUTH_MEMBER: 104,
            // 문자 인증 번호 입력 팝업
            POPUP_AUTH_MEMBER_CHECK: 105,
            // 메세지 확인 팝업 Router 적용
            POPUP_ALERT_ROUTER: 106,
            // 그룹룸 전체 예약 목록
            POPUP_GROOM_RESERVATION_LISt: 175,
            // 250514 상품 이용안내 팝업 
            POPUP_USE_GUIDE: 107
        },
        popup_type: {
            code: 0,
            message: '',
            router: '',
            image_type: '',
            data : null //250519 추가
        },
        // 가맹점 정보.
        store_info: {
            token: '',
            store_id: 1,
            store_name: '스터디카페1호점',
            store_tel_number: '010-2222-2222',
            store_corp: '',
            admin_name: '',
            store_add: '',
            wifi_id: null,
            wifi_password: null,
            store_img : '',
            store_bg_img : '',
            store_top_img : '',
            store_css_folder : '',
            store_imp_code: '',
            logo_width_size: 0,
            logo_height_size: 0,
            auth_use_login: 0,
            auth_use_register: 0,
            auth_use_update: 0,
            store_introduction: '',  
            locker_plus : '0', // 매장옵션 사물함 추가 구매 가능 여부      
        },
        store_pay_info:true, 
        // 가맹점 할인쿠폰 및 마일리지 사용여부.
        use_yn_info: {
            use_yn: '',
            mileage_charge_use_yn:'',
            sale_apply_yn: '',
            seat_sale_yn: '',
            groom_sale_yn: '',
            locker_sale_yn: '',
            use_min_unit: '',
            use_min_amount: '',
            seat_use_yn:'',
            locker_use_yn:'',
            groom_use_yn:'',
        },
        // 로그인 사용자 정보.
        user: {
            token: '',
            user_id: 1,
            name: '',
            user_hp: '',
            parents_hp: '',
            agree_yn: '',
            join_datetime: '',
            mileage_amount: '',
            blacklist_yn: '',
            seat_barcode: '',
            groom_barcode: '',
            password: ''
        },
        // 지도 그룹 정보
        map_group_list: [
            {
                map_group_id: 1,
                map_img: '',
                tab_name: 'tab이름',
                tab_size_width: 0,
                tab_size_height: 0,
                img_width:0,
                img_height:0
            },
        ],
        // 라커 지도 그룹 정보
        locker_group_list: [
            {
                locker_group_id: 0,
                locker_img: '',
                locker_tab_name: 'tab이름',
                locker_img_width:0,
                locker_img_height:0
            },
        ],
        // 좌석 정보
        seat_list: [{
            map_group_id: 0,
            map_group_name: '지도_그룹_이름',
            seats: [{
                seat_id: '좌석_ID',
                start_datetime: '사용불가_시작_일시',
                end_datetime: '사용불가_종료_일시',
                seat_status_code: '좌석_상태_code',
                seat_type_code: '좌석_type_code',
                seat_name: '좌석_이름',
                position_x: 0,
                position_y: 0,
                width_size: 0,
                height_size: 0,
                name: '코드_이름',
                value: '코드_값',
                seat_type_name: '좌석_type_name'
            }]
        }],
        // 좌석 - 타입별 색깔 (범례)
        seat_type_color: [
            {
                seat_type_name: '고정석',
                color: '#bcbcbc,black',
                seat_using_count: 0,
                seat_total_count: 0
            },
        ],
        // 좌석 - 상태별 색깔
        seat_status_color: [
            {
                code: 'SEAT_AVAILABLE',
                code_name: '사용가능',
                color: '#bcbcbc,black',
            },
        ],
        // 사물함 - 리스트
        locker_list: [{
            map_group_id: 0,
            map_group_name: '지도_그룹_이름',
            lockers: [{
                locker_id: '사물함_ID',
                start_datetime: '사용불가_시작_일시',
                end_datetime: '사용불가_종료_일시',
                locker_name: '사물함_이름',
                position_x: 0,
                position_y: 0,
                width_size: 0,
                height_size: 0,
                name: '코드_이름',
                value: '코드_값',
                locker_status_code: '사물함_상태_code'
            }]
        }],
        //사물함 - 상태별 색깔
        locker_status_color: [
            {
                code: 'LOCKER_AVAILABLE',
                code_name: '사용가능',
                code_value: '#bcbcbc,black'
            }
        ],
        // 그룹룸 - 리스트
        groom_list: [{
            map_group_id: '지도_그룹_id',
            map_group_name: '지도_그룹_이름',
            grooms: [{
                groom_id: '그룹룸_ID',
                start_datetime: '사용불가_시작_일시',
                end_datetime: '사용불가_종료_일시',
                seat_count: '좌석_수',
                min_user_count: '최소인원',
                groom_info: '그룹룸_정보',
                groom_name: '그룹룸_이름',
                position_x: '위치_x',
                position_y: '위치_y',
                width_size: '사이즈_가로',
                height_size: '사이즈_세로',
                name: '코드_이름',
                value: '코드_값',
                groom_status_code: '그룹룸_상태_code',
                groom_type_id: '그룹룸_TYPE_ID'
            }]
        }],
        // 그룹룸 - 타입별 색깔(범례)
        groom_type_color: [{
            groom_type_name: '그룹룸_type_name',
            color: '색깔'
        }],
        // 그룹룸 - 상태별 색깔
        groom_status_color: [{
            code: '코드_값',
            code_name: '코드_이름',
            code_value: '코드_색깔'
        }],

        // 가격표

        // 좌석
        seat_price_list: [{
            seat_type_name: '좌석_type_name',
            purchase_goods_yn:'',
            goods_group_name: '상품_그룹_명',
            info: [{
                hours: '시간',
                day_count: '일수',
                cash_amount: '현금_금액',
                card_amount: '카드_금액'
            }]
        }],
        // 사물함
        locker_price_list: {
            locker_name: '사물함',
            info: [{
                use_day_count: '사용_일수',
                cash_amount: '현금_금액',
                card_amount: '카드_금액'
            }]
        },
        // 그룹룸
        groom_price_list: [{
            groom_name: '그룹룸_이름',
            goods_group_name: '상품_그룹_명',
            info: [{
                use_time: '이용시간',
                end_day_count: '만료_일수',
                cash_amount: '현금_금액',
                card_amount: '카드_금액'
            }]
        }],
        // 마일리지
        mileage_price_list: {
            goods_name: '마일리지',
            info: [{
                charge_amount: '충전 마일리지액',
                cash_amount: '현금_금액',
                card_amount: '카드_금액'
            }]
        },
        // 251127 기타상품
        etc_price_list: {
            goods_name: '기타',
            info: [{
                cash_amount: '현금_금액',
                card_amount: '카드_금액'
            }]
        },
        //
        //탭 - 탭코드
        tab_code_data: [],
        // main
        main_start_chk: false,
        login_chk: false,
        page_header_init : "none",      // 메인페이지 header
        main_tab_chk: 0,        // 0 좌석 1 사물함 2 그룹룸
        //price list
        from_groom: false,

        //select things
        select_seat: [{ seat_id: '', seat_name: '', seat_type_code: '', seat_type_name: '', seat_status_code: '' }],
        select_locker: [],
        select_groom: [{ groom_id: '', groom_name: '', groom_type_id: '' }],

        // 좌석 이동을 위한 데이터 셋
        select_my_seat: [{
            seat_name: '',
            seat_id: '',
            seat_use_id: '',
            map_group_id: '',
            main_seat_type_code: '',
            seat_type_code: '',
            use_start_datetime: '',
            use_end_datetime: '',
            goods_end_datetime: ''
        }],
        // 그룹룸 종료를 위한 데이터 셋
        select_my_groom: [{
            groom_name: '',
            groom_id: '',
            groom_use_id: '',
            use_start_datetime: '',
            use_end_datetime: ''
        }],

        //사물함 이동을 위한 데이터 셋
        select_my_locker: [{ locker_id: '', locker_use_id: '', map_group_id: '' }],
        // 좌석 / 사물함 / 그룹룸 이동 성공 파악을 위한 flag (새로고침을 위한 flag)
        seat_move_flag: false,
        locker_move_flag: false,
        groom_move_flag: false,

        //상품 되묻는 팝업을 위한 데이터 셋
        extention_data: [{
            seat_purchase_history_id: '',
            hour: '',
            end_date: '',
            goods_name: '',
            goods_time: '',
        }],
        //상품 되묻는 팝업을 위한 데이터 셋
        groom_extention_data: [{
            groom_purchase_history_id: '',
            hour: '',
            end_date: '',
            goods_name: '',
            goods_time: '',
        }],
        last_url: '/',
        reset_logout_timer_flag: false,
        store_groom_cnt : 0,

        seat_move_step: 0,
        groom_move_step: 0,

        main_page_tab_code:'',          //메인 페이지(좌석배치도에서 그룹룸선택시)에서 그룹룸을 통해 탭전환할때 필요
        main_page_groom_info : {},      // 탭 전환시( 그룹룸의 정보를 갖고오기위해)
        main_page_update_seat : {},
        main_page_update_locker : {},
        main_page_top_menu_code : 'CHOOSE',
        price_page_tab_code:'SEAT',

        cafe_out_page_type : '',        // 퇴실하기 / 재입장하기 페이지 전환을 위한것
        item_update_check : {}, // 좌석 / 사물함 / 그룹룸 status 파악하기 위한 데이터셋
        register_info :{
         flag:false,
         id:'',
         pass:''
        }, // 회원가입을 진행하여 로그인 화면으로 진입했는지 여부를 파악하기 위한
        extention_flag :false, // 연장 진행인지 아닌지를 파악하기위한 flag
        payment_Start: false, // 결제중인지 확인을 위한 flag
        door_kind_list: {},
        use_extend_flag: false,
        groom_reservation_pay: false,
        reservation_info: 0,
        receipt_setting: [],
        receipt_setting_detail: '',
        kiosk_key: '',
        my_color: {
          my_seat_color: '',
          my_locker_color: '',
          text_color: ''
        },
        playList: [],
        userPlayList: [],
        store_list: [],
        using_goods_name:{
            using_seat_goods_name:'',
            using_groom_goods_name:''
        },
        from_front:{
            click:''
        },
        sel_seat_info:{
            seat_name:'',
            seat_type:''
        },
        for_pop_txt:false,
        // 코드 추가 - 2020-12-23 [true: 홍보앱으로 키오스크 모바일 열때, false: 키오스크 모바일을 열때]
        mobile_promotion_yn: false,
        // 바코드에서 이용종료를 위한 정보 저장
        use_end_info:{
            seat_id: '',
            seat_use_id: '',
            seat_left_time: '',
            seat_use_end_time: '',
            seat_expire_time: ''
        },
        store_option : [],
        refund_text: '' // 환불규정
    },
    getters: { 
        // 코드 추가 - 2020-12-23
        get_mobile_promotion_yn: function (state) {
            return state.mobile_promotion_yn;
        }, 
        getFor_pop_txt: function (state) {
            return state.for_pop_txt;
        },       
        getStore_pay_info: function (state) {
            return state.store_pay_info;
        },
        getSel_seat_info: function (state) {
            return state.sel_seat_info;
        },
        getFrom_front: function (state) {
            return state.from_front;
        },
        getGoods_name: function (state) {
            return state.using_goods_name;
        },
        getExtention_flag: function (state) {
            return state.extention_flag;
        },
        getItem_register_info: function (state) {
            return state.register_info;
        },
        getItem_update_check: function (state) {
            return state.item_update_check;
        },
        get_last_url: function (state) {
            return state.last_url;
        },
        getExtention_data: function (state) {
            return state.extention_data;
        },
        getGroomExtention_data: function (state) {
            return state.groom_extention_data;
        },
        getUseyn: function (state) {
            return state.use_yn_info;
        },
        get_str_datetime: function () {
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear();
            var h = today.getHours();
            var m = today.getMinutes();
            if (h < 10) {
                h = '0' + h;
            }

            if (m < 10) {
                m = '0' + m;
            }
            if (dd < 10) {
                dd = '0' + dd;
            }

            if (mm < 10) {
                mm = '0' + mm;
            }

            var str_date = yyyy + '-' + mm + '-' + dd + ' ' + h + ':' + m + ':00';
            return str_date;
        },
        increment: function (state) {
            state.count++
        },
        getToken: function (state) {
            if (state.user.hasOwnProperty('token') && state.user.token != '') return state.user.token;
            return state.store_info.token;
        },
        getKioskToken: function (state) {
            return state.store_info.token;
        },
        getHost: function (state) {
            return state.host;
        },
        getStoreId: function (state) {
            return state.store_info.store_id;
        },
        getStoreInfo: function (state) {
            return state.store_info;
        },
        getStoreList: function (state) {
            return state.store_list;
        },
        getUser: function (state) {
            return state.user;
        },
        getUserId: function (state) {
            return state.user.user_id;
        },
        get_map_group_list: function (state) {
            return state.map_group_list; // 지도 그룹 정보
        },
        get_locker_group_list: function (state) {
            return state.locker_group_list; // 라커지도 그룹 정보
        },
        get_seat_list: function (state) {
            for (let i = 0; i < state.seat_list.length; i++) {
                for (let z = 0; z < state.seat_list[i].seats.length; z++) {
                    var color = state.seat_list[i].seats[z].code_value.split(',');
                    state.seat_list[i].seats[z].code_value = color[0];
                    state.seat_list[i].seats[z].code_value_text = color[1];
                }

            }
            var data = JSON.stringify(state.seat_list);
            var data2 = JSON.parse(data);
            return data2; // 매장 좌석 정보
        },
        get_seat_type_color: function (state) {
            return state.seat_type_color; // 좌석 - 타입별 색깔 (범례)
        },
        get_seat_status_color: function (state) {
            return state.seat_status_color; // 좌석 - 상태별 색깔
        },
        get_locker_list: function (state) {
            for (let i = 0; i < state.locker_list.length; i++) {
                for (let z = 0; z < state.locker_list[i].lockers.length; z++) {
                    var color = state.locker_list[i].lockers[z].code_value.split(',');
                    state.locker_list[i].lockers[z].code_value = color[0];
                    state.locker_list[i].lockers[z].code_value_text = color[1];
                }

            }
            return state.locker_list; // 매장 사물함 정보
        },
        get_locker_status_color: function (state) {

            return state.locker_status_color; // 사물함 - 상태별 색깔
        },
        get_groom_list: function (state) {
            return state.groom_list; // 매장 그룹룸 정보
        },
        get_groom_type_color: function (state) {
            return state.groom_type_color; // 그룹룸 - 타입별 색깔 (범례)
        },
        get_groom_status_color: function (state) {
            return state.groom_status_color; // 그룹룸 - 상태별 색깔
        },

        get_popup_type: function (state) {
            return state.popup_type;
        },
        get_popup_code: function (state) {
            return state.POPUP_CODE;
        },
        get_select_seat: function (state) {// 선택된 좌석
            return state.select_seat;
        },
        get_select_locker: function (state) {// 선택된 사물함
            return state.select_locker;
        },
        get_select_groom: function (state) {// 선택된 그룹룸
            return state.select_groom;
        },
        get_seat_price_list: function (state) {

            return state.seat_price_list; // 좌석 가격정보
        },
        get_locker_price_list: function (state) {

            return state.locker_price_list; // 사물함 가격정보
        },
        get_groom_price_list: function (state) {

            return state.groom_price_list; // 그룹룸 가격정보
        },
        get_mileage_price_list: function (state) {

            return state.mileage_price_list; // 마일리지 가격정보
        },
        get_etc_price_list: function (state) {

            return state.etc_price_list; // 251127 기타상품 가격정보
        },
        get_tab_code_list: function (state) {
            return state.tab_code_data  // tab code 데이터
        },
        get_my_seat_data: function (state) {
            return state.select_my_seat // 선택된 내가 사용중인 좌석데이터
        },
        get_my_groom_data: function (state) {
            return state.select_my_groom // 선택된 내가 사용중인 그룹룸데이터
        },
        get_my_locker_data: function (state) {
            return state.select_my_locker // 선택된 내가 사용중인 사물함데이터
        },
        get_seat_move_flag: function (state) {
            return state.seat_move_flag // seat이동 파악 flag
        },
        get_groom_move_flag: function (state) {
            return state.groom_move_flag // groom이동 파악 flag
        },
        get_locker_move_flag: function (state) {
            return state.locker_move_flag // locker이동 파악 flag
        },
        get_login_yn: function (state) {
            return state.login_chk
        },
        get_change_store_check: function (state) {
            return state.user_id
        },
        get_page_header_init: function(state){
            return state.page_header_init   // 페이지 헤더용
        },
        get_reset_logout_timer_flag: function(state){
            return state.reset_logout_timer_flag;   // 자동 로그아웃 타이머 플래그
        },
        get_store_groom_cnt: function(state){
            return state.store_groom_cnt;
        },
        get_seat_move_step: function(state){
            return state.seat_move_step;
        },
        get_groom_move_step: function(state){
            return state.groom_move_step;
        },
        get_main_page_tab_code: function(state){
            return {'main_page_code' : state.main_page_tab_code, 'main_page_groom_info' : state.main_page_groom_info};
        },
        get_main_page_update_seat: function(state){
            return state.main_page_update_seat;
        },
        get_main_page_update_locker: function(state){
            return state.main_page_update_locker;
        },
        get_cafe_out_page_type: function(state){
            return state.cafe_out_page_type;
        },
        get_price_page_tab_code: function(state){
            return state.price_page_tab_code;
        },
        get_main_page_top_menu_code: function(state){
            return state.main_page_top_menu_code;
        },
        get_reservation_info: function(state){
            return state.reservation_info;
        },
        get_payment_Start: function(state){
            return state.payment_Start;
        },
        get_door_kind_list: function(state){
            return state.door_kind_list;
        },
        get_use_extend_flag: function(state){
            return state.use_extend_flag;
        },
        get_store_bg_img_url: function(state){
            var temp_store_bg_image = state.store_info.store_bg_img;
            if(typeof temp_store_bg_image == 'undefined' || temp_store_bg_image == ''){
                temp_store_bg_image = '';
            }else{
                temp_store_bg_image = config.SYS_HOST+'/images/kiosk/bg/'+temp_store_bg_image;
            }
            return temp_store_bg_image;
        },
        get_store_top_img_url: function(state){
            var temp_store_top_image = state.store_info.store_top_img;
            if(typeof temp_store_top_image == 'undefined' || temp_store_top_image == ''){
                temp_store_top_image = '';
            }else{
                temp_store_top_image = config.SYS_HOST+'/images/kiosk/top/'+temp_store_top_image;
            }
            return temp_store_top_image;
        },
        get_groom_reservation_pay: function(state){
            return state.groom_reservation_pay;
        },
        get_seat_barcode: function(state){
            return state.seat_barcode;
        },
        get_groom_barcode: function(state){
            return state.groom_barcode;
        },
        get_receipt_setting: function(state){
            return state.receipt_setting;
        },
        get_receipt_setting_detail: function(state){
            var array = [];
            state.receipt_setting.forEach(e => {
                if(e["print_kind"] == state.receipt_setting_detail){
                    array = e;
                }
            });
            return array;
        },
        get_kiosk_key: function(state){
            return state.kiosk_key;
        },
        get_my_color: function(state){
            return state.my_color;
        },
        get_playList: function(state){
            return state.playList;
        },
        get_userPlayList: function(state){
            return state.userPlayList;
        },
        get_use_end_info: function(state){
            return state.use_end_info;
        },
        get_store_option: function(state){
            return state.store_option;
        },
        get_refund_text: function(state){
          return state.refund_text;
        },
        get_guide_data: function (state) { //이용안내 데이터 가져오기용
            return state.popup_type.data;
        },
        get_guide_popup_code: function (state) {
            return state.POPUP_CODE;
        },
    },
    mutations: {
        // 코드 추가 - 2020-12-23
        set_mobile_promotion_yn(state, value) {
            state.mobile_promotion_yn = value;
        },   
        setFor_pop_txt(state, value) {                   
            state.for_pop_txt = value;
        },        
        setSel_seat_info(state, value) {            
            state.sel_seat_info.seat_name = value.seat_name;
            state.sel_seat_info.seat_type = value.seat_type;
        },        
        setFrom_front(state, value) {                   
            state.from_front.click = value;
        },     
        setGoods_name(state, value) {               
            state.using_goods_name.using_seat_goods_name = value.seat_goods_name;
            state.using_goods_name.using_groom_goods_name = value.groom_goods_name;
        },
        setExtention_flag(state, value) {
            state.extention_flag = value;
        },
        set_use_extend_flag(state, value) {
            state.use_extend_flag = value;
        },
        set_Item_register_info(state, value) {
            state.register_info.flag = value.flag;
            state.register_info.id = value.id;
            state.register_info.pass = value.pass;
        },
        set_Item_update_check(state, value) {
            state.item_update_check.item_id = value.item_id;
            state.item_update_check.item = value.item;
            state.item_update_check.last_status = value.last_status;
        },
        set_Last_URL(state, value) {
            state.last_url = value;
        },
        set_store_info(state, { store_info }) {
            state.store_info = store_info;
        },
        set_store_list(state, { store_list }) {
            state.store_list = store_list;
        },
        set_useyn_info(state, use_yn_info) {
            state.use_yn_info = use_yn_info.vo[0];
        },
        set_store_token(state, token) {
            state.store_info.token = token.vo;
        },
        set_user(state, { user }) {
            state.user = user;
        },
        set_user_token(state, token) {
            state.user.token = token.vo;
        },
        change_main_tab_chk(state, { value }) {
            state.main_tab_chk = value; // main tab defalt value 셋팅 0 = 좌석 , 1 = 사물함 , 2 = 그룹룸
        },
        change_from_groom(state, { value }) {
            state.main_tab_chk = value; //true 메인 false 그룹룸으로 탭이동
        },
        change_login_chk(state, { value }) {
            state.login_chk = value; // 로그인 확인여부 true / false
        },
        change_store_check(state, { value }) {
            state.user_id = value; 
        },
        change_main_start_chk(state, { value }) {
            state.main_start_chk = value; // 메인 화면스탭 체크
        },
        set_map_group_list(state, value) {
            state.map_group_list.splice(0, state.map_group_list.length); // 지도 그룹 정보
            value.vo.forEach((element, index) => {
                state.map_group_list.push(element);
            });
        },
        set_locker_group_list(state, value) {
            state.locker_group_list.splice(0, state.locker_group_list.length); // 라커지도 그룹 정보
            value.vo.forEach((element, index) => {
                state.locker_group_list.push(element);
            });
        },
        set_seat_list(state, value) {
            state.seat_list.splice(0, state.seat_list.length); // 좌석 리스트 정보
            value.vo.forEach((element, index) => {
                state.seat_list.push(element);
            });
        },
        set_seat_type_color(state, value) {
            state.seat_type_color.splice(0, state.seat_type_color.length); // 좌석 - 타입별 색깔 (범례)
            value.forEach((element, index) => {
                state.seat_type_color.push(element);
            });
        },
        set_seat_status_color(state, value) {
            state.seat_status_color.splice(0, state.seat_status_color.length); // 좌석 - 상태별 색깔
            value.vo.forEach((element, index) => {

                state.seat_status_color.push(element);
            });
        },
        set_locker_status_color(state, value) {
            state.locker_status_color.splice(0, state.locker_status_color.length); // 사물함 - 상태별 색깔
            value.vo.forEach((element, index) => {
                state.locker_status_color.push(element);
            });
        },
        set_locker_list(state, value) {
            state.locker_list.splice(0, state.locker_list.length); // 사물함 리스트 정보
            value.vo.forEach((element, index) => {
                state.locker_list.push(element);
            });
        },
        set_groom_list(state, value) {
            state.groom_list.splice(0, state.groom_list.length); // 그룹룸 리스트 정보
            value.vo.forEach((element, index) => {
                state.groom_list.push(element);
            });
        },
        set_groom_type_color(state, value) {
            state.groom_type_color.splice(0, state.groom_type_color.length); // 그룹룸 - 타입별 색깔 (범례)
            value.vo.forEach((element, index) => {
                state.groom_type_color.push(element);
            });
        },
        set_groom_status_color(state, value) {
            state.groom_status_color.splice(0, state.groom_status_color.length); // 그룹룸 - 상태별 색깔
            value.vo.forEach((element, index) => {
                state.groom_status_color.push(element);
            });
        },

        set_reset_popup_type(state) {
            state.popup_type.message = '';
            state.popup_type.router = '';
            state.popup_type.code = 0;
            state.popup_type.image_type = '';
            state.popup_type.data = null; //250519 이용안내 데이터때문에 추가함
        },
        set_popup_type(state, value) {
            if (value.message) state.popup_type.message = value.message;
            if (value.router) state.popup_type.router = value.router;
            if (value.image_type) state.popup_type.image_type = value.image_type;
            if (value.data) state.popup_type.data = value.data; //250519 이용안내 데이터때문에 추가함
            state.popup_type.code = value.code;
        },
        set_select_seat(state, value) {
            state.select_seat[0].seat_id = value.seat_id;
            state.select_seat[0].seat_name = value.seat_name;
            state.select_seat[0].seat_type_code = value.seat_type_code;
            state.select_seat[0].seat_type_name = value.seat_type_name;
            state.select_seat[0].seat_status_code = value.seat_status_code;
            state.select_seat[0].main_seat_type_code = value.main_seat_type_code;
        },
        set_select_locker(state, value) {
            state.select_locker = value;
        },
        set_select_groom(state, value) {
            state.select_groom[0].groom_id = value.groom_id;
            state.select_groom[0].groom_name = value.groom_name;
            state.select_groom[0].groom_type_id = value.groom_type_id;
            state.select_groom[0].groom_seat_count = value.groom_seat_count;
            state.select_groom[0].min_user_count = value.min_user_count;
            state.select_groom[0].type_name = value.type_name;
            state.select_groom[0].groom_goods_group_id = value.groom_goods_group_id;
            state.select_groom[0].groom_goods_name = value.groom_goods_name;
            state.select_groom[0].selection_plan_code = value.selection_plan_code;
            state.select_groom[0].goods_group_name = value.goods_group_name;
        },

        set_seat_price_list(state, value) {
            state.seat_price_list.splice(0, state.seat_price_list.length); // 좌석 가격 정보
            value.vo.forEach((element, index) => {
                state.seat_price_list.push(element);
            });
        },
        set_locker_price_list(state, value) {
            if( Object.keys(value.vo).length !== 0){
                state.locker_price_list.info.splice(0, state.locker_price_list.info.length); // 사물함 가격 정보
                value.vo.info.forEach((element, index) => {
                    state.locker_price_list.info.push(element);
                });
            }
        },
        set_groom_price_list(state, value) {
            state.groom_price_list.splice(0, state.groom_price_list.length); // 그룹룸 가격 정보
            value.vo.forEach((element, index) => {
                state.groom_price_list.push(element);
            });
        },
        set_mileage_price_list(state, value) {
            if( Object.keys(value.vo).length !== 0){
                state.mileage_price_list.info.splice(0, state.mileage_price_list.info.length); // 마일리지 가격 정보
                value.vo.info.forEach((element, index) => {
                    state.mileage_price_list.info.push(element);
                });
            }
        },
        //251127 기타상품 가격정보 
        set_etc_price_list(state, value) {
            if( Object.keys(value.vo).length !== 0){
                state.etc_price_list.info.splice(0, state.etc_price_list.info.length);
                value.vo.info.forEach((element, index) => {
                    state.etc_price_list.info.push(element);
                });
            }
        },
        set_tab_code_list(state, value) {
            state.tab_code_data = value.vo;
        },
        set_my_seat_data(state, value) {
            state.select_my_seat[0].seat_name = value.seat_name;
            state.select_my_seat[0].seat_id = value.seat_id;
            state.select_my_seat[0].seat_use_id = value.seat_use_id;
            state.select_my_seat[0].map_group_id = value.map_group_id;
            state.select_my_seat[0].main_seat_type_code = value.main_seat_type_code;
            state.select_my_seat[0].use_start_datetime = value.use_start_datetime;
            state.select_my_seat[0].use_end_datetime = value.use_end_datetime;
            state.select_my_seat[0].goods_end_datetime = value.goods_end_datetime;
            state.select_my_seat[0].left_time = value.left_time;
            state.select_my_seat[0].use_total_time = value.use_total_time;
            // 코드 추가 - 2020-11-26
            state.select_my_seat[0].seat_type_code = value.seat_type_code;
        },
        set_my_groom_data(state, value) {
            state.select_my_groom[0].groom_name = value.groom_name;
            state.select_my_groom[0].groom_id = value.groom_id;
            state.select_my_groom[0].groom_use_id = value.groom_use_id;
            state.select_my_groom[0].use_start_datetime = value.use_start_datetime;
            state.select_my_groom[0].use_end_datetime = value.use_end_datetime;
        },
        set_my_locker_data(state, value) {
            state.select_my_locker[0].locker_id = value.locker_id;
            state.select_my_locker[0].locker_use_id = value.locker_use_id;
        },
        set_seat_move_flag(state, value) {
            state.seat_move_flag = value;
        },
        set_groom_move_flag(state, value) {
            state.groom_move_flag = value;
        },
        set_locker_move_flag(state, value) {
            state.locker_move_flag = value;
        },
        set_extention_data(state, value) {
            state.extention_data[0].seat_purchase_history_id = value.seat_purchase_history_id;
            state.extention_data[0].hour = value.hour;
            state.extention_data[0].end_date = value.end_date;
            state.extention_data[0].goods_name = value.goods_name;
            state.extention_data[0].goods_time = value.goods_time;

        },
        set_groom_extention_data(state, value) {
            state.groom_extention_data[0].groom_purchase_history_id = value.groom_purchase_history_id;
            state.groom_extention_data[0].hour = value.hour;
            state.groom_extention_data[0].end_date = value.end_date;
            state.groom_extention_data[0].goods_name = value.goods_name;
            state.groom_extention_data[0].goods_time = value.goods_time;

        },
        set_page_header_init(state, value){
            state.page_header_init = value.style;
        },
        user_logout(state, value){
            state.user.token = '';
            state.user.user_id = 0;
            state.user.name = '';
            state.user.user_hp = '';
            state.user.parents_hp = '';
            state.user.agree_yn = '';
            state.user.join_datetime = '';
            state.user.mileage_amount = '';
            state.user.blacklist_yn = '';
            state.login_chk = false; // 로그인 확인여부 true / false
            state.last_url = '';
            state.main_tab_chk = 0; // main tab defalt value 셋팅 0 = 좌석 , 1 = 사물함 , 2 = 그룹룸
        },
        reset_logout_timer_true(state, value){
            state.reset_logout_timer_flag = true;
        },
        reset_logout_timer_false(state, value){
            state.reset_logout_timer_flag = false;
        },
        set_store_groom_cnt: function(state, value){
            state.store_groom_cnt = value.groom_cnt;
        },
        set_seat_move_step: function(state, value){
            state.seat_move_step = value;
        },
        set_groom_move_step: function(state, value){
            state.groom_move_step = value;
        },
        set_main_page_tab_code : function(state, value){
            state.main_page_tab_code = value.tab_code;
            state.main_page_groom_info = value.groom_info;
        },
        set_main_page_update_seat: function(state, value){
            state.main_page_update_seat = value;
        },
        set_main_page_update_locker: function(state, value){
            state.main_page_update_locker = value;
        },
        set_cafe_out_page_type : function(state, value){
            state.cafe_out_page_type = value.page_type;
        },
        set_price_page_tab_code: function(state, value){
            state.price_page_tab_code = value.tab_code;
        },
        set_main_page_top_menu_code: function(state, value){
            state.main_page_top_menu_code = value.menu_code;
        },
        set_reservation_info: function(state, value){
            state.reservation_info = value;
        },
        set_payment_Start: function(state, value){
            state.payment_Start = value;
        },
        set_door_kind_list: function(state, value){
            state.door_kind_list = value;
        },
        set_css_file_remove(state, value){
            document.querySelectorAll('style,link[rel="stylesheet"]').forEach(function(item){
                var fileName = item.href;
                if(fileName !== undefined){
                    if(fileName.toString().indexOf(value.value) != -1){
                        item.remove();
                    }
                }
            });
        },
        set_groom_reservation_pay: function(state, value){
            state.groom_reservation_pay = value;
        },
        set_seat_barcode: function(state, value){
            state.seat_barcode = value;
        },
        set_groom_barcode: function(state, value){
            state.groom_barcode = value;
        },
        set_receipt_setting: function(state, value){
            state.receipt_setting = value;
        },
        set_receipt_setting_detail: function(state, value){
            state.receipt_setting_detail = value;
        },
        set_kiosk_key: function(state, value){
            state.kiosk_key = value;
        },
        set_my_color(state, value) {
            state.my_color.my_locker_color = value.vo[0].color;
            state.my_color.my_seat_color = value.vo[1].color;
            state.my_color.text_color = value.vo[2].color;
        },
        set_playList(state,value){
            state.playList = value;
        },
        set_userPlayList(state,value){
            state.userPlayList = value;
        },        
        set_use_end_info(state, value){
            state.use_end_info.seat_id = value.seat_id;
            state.use_end_info.seat_use_id = value.seat_use_id;
            state.use_end_info.seat_left_time = value.seat_left_time;
            state.use_end_info.seat_use_end_time = value.seat_use_end_time;
            state.use_end_info.seat_expire_time = value.seat_expire_time;
        },
        set_store_option: function(state, value){
            state.store_option = value;
        },        
        set_refund_text: function(state, value){
            state.refund_text = value;
        }
    },
    actions: {
        [config.ACT_GET_INIT_DATA](store) {
            const payloadArray = [];
            // 좌석 - 그룹맵
            payloadArray.push({ type: config.REQ_SEAT_TAB_GET_LIST, data: {} });
            // 좌석 - 타입별 색깔 (범례)
            // payloadArray.push({ type: config.REQ_SEAT_USER_GET_TYPE_COLOR_LIST, data: {} });
            // 좌석 - 상태별 색깔
            payloadArray.push({ type: config.REQ_SEAT_USER_GET_STATUS_COLOR_LIST, data: {} });
            // // 좌석 - 리스트
            // payloadArray.push({ type: config.REQ_SEAT_USER_GET_LIST, data: {} });
            // // 사물함 - 리스트
            // payloadArray.push({ type: config.REQ_LOCKER_GET_LIST, data: {} });
            // 사물함 - 상태별 색깔
            payloadArray.push({ type: config.REQ_LOCKER_USER_GET_STATUS_COLOR_LIST, data: {} });
            // 그룹룸 - 리스트
            // payloadArray.push({ type: config.REQ_GROOM_GROUPROOM_GET_LIST, data: {} });
            // 그룹룸 - 타입별 색깔 (범례)
            payloadArray.push({ type: config.REQ_GROOM_USER_GET_TYPE_COLOR_LIST, data: {} });
            // 그룹룸 - 상태별 색깔
            payloadArray.push({ type: config.REQ_GROOM_USER_GET_STATUS_COLOR_LIST, data: {} });
            // 좌석 - 가격정보
            payloadArray.push({ type: config.REQ_SEAT_PRICE_GET_LIST, data: {} });
            // 사물함 가격정보
            payloadArray.push({ type: config.REQ_LOCKER_PRICE_GET_LIST, data: {} });
            // 그룹룸 가격정보
            payloadArray.push({ type: config.REQ_GROOM_PRICE_GET_LIST, data: {} });
            // 메인 탭 및 상품코드 리스트
            payloadArray.push({ type: config.REQ_GET_GOODS_TYPE_LIST, data: {} });
            // 매장 할인및 마일리지 사용여부
            payloadArray.push({ type: config.REQ_MILEAGE_AND_SALE_USE_YN, data: {} });
            // 사물함 - 그룹맵 2020 09 01추가
            payloadArray.push({ type: config.REQ_LOCKER_TAB_GET_LIST, data: {} });
             // 내 좌석
            payloadArray.push({ type: config.REQ_MY_COLOR_LIST, data: {} });
              // 환불규정
            payloadArray.push({ type: config.REQ_REFUND_GET, data: {} });
             // 좌석 - 타입별 색깔 (범례)
            // payloadArray.push({ type: config.REQ_SEAT_USER_GET_TYPE_COLOR_LIST, data: {} });

            return store.dispatch(
                config.ACT_SERVER_REQUEST_ALL, payloadArray
            ).then(function (responseList) {
                responseList.forEach((response, index) => {
                    switch (index) {
                        case 0:
                            // 좌석 - 그룹맵;
                            store.commit('set_map_group_list', {
                                vo: response.data
                            });
                            break;
                        // case 1:
                        //     // 좌석 - 타입별 색깔 (범례)
                        //     store.commit('set_seat_type_color', {
                        //         vo: response.data
                        //     });
                        //     break;
                        case 1:
                            // 좌석 - 상태별 색깔
                            store.commit('set_seat_status_color', {
                                vo: response.data
                            });
                            break;
                        // case 3:
                        //     // 좌석 - 리스트
                        //     store.commit('set_seat_list', {
                        //         vo: response.data
                        //     });
                        //     break;
                        // case 4:
                        //     // 사물함 - 리스트
                        //     store.commit('set_locker_list', {
                        //         vo: response.data
                        //     });
                        //     break;
                        case 2:
                            // 사물함 - 상태별 색깔
                            store.commit('set_locker_status_color', {
                                vo: response.data
                            });
                            break;
                        // case 4:
                        //     // 그룹룸 - 리스트
                        //     store.commit('set_groom_list', {
                        //         vo: response.data
                        //     });
                        //     break;
                        case 3:
                            // 그룹룸 - 타입별 색깔 (범례)
                            store.commit('set_groom_type_color', {
                                vo: response.data
                            });
                            break;
                        case 4:
                            // 그룹룸 - 상태별 색깔
                            store.commit('set_groom_status_color', {
                                vo: response.data
                            });
                            break;
                        case 5:
                            // 좌석 - 가격정보
                            store.commit('set_seat_price_list', {
                                vo: response.data
                            });
                            break;
                        case 6:
                            // 사물함 - 가격정보
                            store.commit('set_locker_price_list', {
                                vo: response.data
                            });
                            break;
                        case 7:
                            // 그룹룸 - 가격정보
                            store.commit('set_groom_price_list', {
                                vo: response.data
                            });
                            break;
                        case 8:
                            store.commit('set_tab_code_list', {
                                vo: response.data
                            });
                            break;
                        case 9:
                            // 매장 할인쿠폰 및 마일리지 - 사용정보
                            store.commit('set_useyn_info', {
                                vo: response.data
                            });
                            break;
                        case 10:
                            // 사물함 그룹맵 2020 09 01추가
                            store.commit('set_locker_group_list', {
                                vo: response.data
                            });
                            break;
                        case 11:
                            // 매장 할인쿠폰 및 마일리지 - 사용정보
                            store.commit('set_my_color', {
                                vo: response.data
                            });
                            break;
                        case 12:
                            // 환불규정
                            store.commit('set_refund_text', response.data);
                            break;
                        // case 12:
                        //     // 좌석 - 타입별 색깔 (범례)
                        //     store.commit('set_seat_type_color', {
                        //         vo: response.data
                        //     });
                        //     break;
                    }
                });

                // 갱신된 token 점검.
                if (responseList[0].data.hasOwnProperty('token') && responseList[0].data.hasOwnProperty('token_type')) {
                    let response = responseList[0];
                    switch (response.data.token_type.code) {
                        case 1:
                            // user
                            store.commit('set_user_token', {
                                vo: response.data.token
                            });
                            break;
                        case 2:
                            // kiosk
                            store.commit('set_store_token', {
                                vo: response.data.token
                            });
                            break;
                    }
                }
            }).catch(function (error) {
                console.log('error=============>', error);
                return error;
            });
        },


        /**
         * 사용방법 - 아래 내용 복사 하여 type 및 data 수정하여 요청.
         * // 좌석 정보 요청.
            const type = config.REQ_SEAT_TAB_GET_LIST;
            const data = {}; // store_id는 공통으로 추가하니까 생략. 예) {user_id: 123}
            this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(function (response) {
            }).catch(function (error) {
                console.log('error=============>',error);
            });

            // 여러건 호출
            Promise.all(
                [
                    this.$store.dispatch(type.action_name, {
                        type: type,
                        data: data
                    }),
                    this.$store.dispatch(type.action_name, {
                        type: type,
                        data: data
                    })
                ]
            ).then(function (responseList) {
                // 응답 - 요청 순서별 응답 array
            }).catch(function (error) {
            });
         * @param {*} store
         * @param {*} payload - {type:type, data:data}
         */
        [config.ACT_SERVER_REQUEST](store, payload) {
            if (!payload.type) {
                return Promise.reject(new Error('[store > actions] 호출시 반드시 type을 설정하셔야 합니다.'));
            }

            // axios parameter 생성.
            const axiosParms = createAxiosParams(store, payload);
            if (payload.type.method == 'get') {
                return axios[payload.type.method](
                    axiosParms.reqURL, Object.assign({}, axiosParms.reqData, axiosParms.reqHeaders)
                )
                    .then(function (response) {
                        if(timeDiffFlag){
                          return false;
                        }
                        if(moment().diff(moment(response.headers['date'])) > 5*60*1000){
                          timeDiffFlag = true;
                          //alert('현재 기기 시간이 서버 시간과 다릅니다.\n정상적인 서비스 이용을 위해 기기의 날짜 및 시간을 확인해주세요');
                          alert('앱 사용 중 시간 변조가 감지되는 경우, 이용이 제한됩니다.');
                          window.close();
                          return false;
                        }

                        // 갱신된 token 점검.
                        if (response.data.hasOwnProperty('token') && response.data.hasOwnProperty('token_type')) {
                            switch (response.data.token_type.code) {
                                case 1:
                                    // user
                                    store.commit('set_user_token', {
                                        vo: response.data.token
                                    });
                                    break;
                                case 2:
                                    // kiosk
                                    store.commit('set_store_token', {
                                        vo: response.data.token
                                    });
                                    break;
                            }
                        }

                        return response.data;
                    })
                    .catch(function (error) {
                        return error;
                    });
            } else {
                return axios[payload.type.method](
                    axiosParms.reqURL, axiosParms.reqData, axiosParms.reqHeaders
                )
                    .then(function (response) {
                        return response.data;
                    })
                    .catch(function (error) {
                        // console.log(error);
                        return error;
                    });
            }
        },
        async [config.ACT_SERVER_REQUEST_ASYNC](store, payload) {
            if (!payload.type) {
                return Promise.reject(new Error('[store > actions] 호출시 반드시 type을 설정하셔야 합니다.'));
            }
            // axios parameter 생성.
            const axiosParms = createAxiosParams(store, payload);
            let response;
            if (payload.type.method == 'get') {
                response = await axios[payload.type.method](axiosParms.reqURL, Object.assign({}, axiosParms.reqData, axiosParms.reqHeaders));
            } else {
                response = await axios[payload.type.method](axiosParms.reqURL, axiosParms.reqData, axiosParms.reqHeaders);
            }
            // 갱신된 token 점검.
            if (response.data.hasOwnProperty('token') && response.data.hasOwnProperty('token_type')) {
                switch (response.data.token_type.code) {
                    case 1:
                        // user
                        store.commit('set_user_token', {
                            vo: response.data.token
                        });
                        break;
                    case 2:
                        // kiosk
                        store.commit('set_store_token', {
                            vo: response.data.token
                        });
                        break;
                }
            }

            return response.data;
        },
        /**
         * 사용방법 - 아래 내용 복사 하여 type 및 data 수정하여 요청.
         * // 좌석 정보 요청.
              const payloadArray = [{type:config.REQ_SEAT_TAB_GET_LIST, data:{}}, {type:config.REQ_SEAT_TAB_GET_LIST, data:{}}];
              this.$store.dispatch(
                  config.ACT_SERVER_REQUEST_ALL, payloadArray
              ).then(function (responseList) {
              }).catch(function (error) {
                  console.log('error=============>', error);
              });
           * @param {*} store
           * @param {*} payloadArray - [{type:type, data:data}]
         */
        [config.ACT_SERVER_REQUEST_ALL](store, payloadArray) {
            payloadArray.forEach(function (payload) {
                if (!payload.type) {
                    return Promise.reject(new Error('[store > actions] 호출시 반드시 type을 설정하셔야 합니다.'));
                }
            });

            // axios parameter 생성.
            const axiosParmsArray = payloadArray.map(function (payload) {
                return createAxiosParams(store, payload);
            });

            // axios all 호출
            return axios.all(axiosParmsArray.map((axiosParms) => {
                return getAxiosInsctance(axiosParms);
            }))
                .then(responseArr => {
                    // 갱신된 token 점검.
                    if (responseArr[0].data.hasOwnProperty('token') && responseArr[0].data.hasOwnProperty('token_type')) {
                        let response = responseArr[0];
                        switch (response.data.token_type.code) {
                            case 1:
                                // user
                                store.commit('set_user_token', {
                                    vo: response.data.token
                                });
                                break;
                            case 2:
                                // kiosk
                                store.commit('set_store_token', {
                                    vo: response.data.token
                                });
                                break;
                        }
                    }

                    //this will be executed only when all requests are complete
                    var responseList = responseArr.map(function (response) {
                        return response.data;
                    });
                    return responseList;
                }).catch((error) => {
                    // console.error(error);
                    return error;
                });
        },
    }
})



// WEBPACK FOOTER //
// ./src/javascript/store.js